import { router } from '@inertiajs/react'
import { KeyRound } from 'lucide-react'
import { useState } from 'react'
import OrganizationAuthConfigRow from '@/frontend/pages/CommandCenter/Organizations/components/OrganizationAuthConfigRow'
import type {
  OrganizationAuthConfigCopy,
  OrganizationAuthConfigIntegration,
  OrganizationAuthConfigs,
} from '@/frontend/pages/CommandCenter/Organizations/components/organizationAuthConfigTypes'

interface Props {
  organizationSlug: string
  catalog: OrganizationAuthConfigs
  copy: OrganizationAuthConfigCopy
}

export default function OrganizationAuthConfigsSection({ organizationSlug, catalog, copy }: Props) {
  const [busySlug, setBusySlug] = useState<string | null>(null)

  const updateAuthConfig = (integration: OrganizationAuthConfigIntegration, authConfigId: string) => {
    if (busySlug !== null || authConfigId === (integration.organizationAuthConfigId ?? '')) return

    setBusySlug(integration.slug)
    router.patch(`/cc/organizations/${organizationSlug}/composio_auth_config`, {
      toolkit_slug: integration.slug,
      auth_config_id: authConfigId,
    }, {
      preserveScroll: true,
      onFinish: () => setBusySlug(null),
    })
  }

  return (
    <section className="overflow-hidden rounded-lg border border-border bg-card">
      <div className="flex items-start gap-3 border-b border-border px-4 py-4">
        <KeyRound className="mt-0.5 h-4 w-4 text-muted-foreground" />
        <div>
          <h3 className="text-base font-semibold text-foreground">{copy.title}</h3>
          <p className="mt-1 text-sm text-muted-foreground">{copy.description}</p>
        </div>
      </div>
      <div>
        {catalog.integrations.map((integration) => (
          <OrganizationAuthConfigRow
            key={integration.slug}
            integration={integration}
            copy={copy}
            disabled={!catalog.loaded || busySlug !== null}
            onChange={(authConfigId) => updateAuthConfig(integration, authConfigId)}
          />
        ))}
        {catalog.integrations.length === 0 && (
          <p className="px-4 py-8 text-center text-sm text-muted-foreground">{copy.empty}</p>
        )}
      </div>
    </section>
  )
}
